import {
    CreateMatchPlayerCommandOfMatchPlayer,
    EventVm,
    UpdateEventCommand,
} from '../../../../utils/api';
import Shot from './Shot';

interface OwnProps {
    onAttackTypeChange?: () => void;
    isHomeTeam: boolean;
    event: UpdateEventCommand;
    lineups: CreateMatchPlayerCommandOfMatchPlayer[];
    events: EventVm[];
    selectedHomeKeeper: number;
    selectedAwayKeeper: number;
    /** Overtime UI mode: hide other attack types; only Pen SO + lob/skip. */
    penaltyShootoutRecordingMode: boolean;
    updateEvent: (event: UpdateEventCommand) => void;
    clearEvent: () => void;
    deleteEvent: (event: EventVm) => void;
}

export type Props = OwnProps;

export default Shot;
